import { generateHTML } from "@tiptap/html"
import StarterKit from "@tiptap/starter-kit"

import AwsImage from "components/dashboard/AwsImage"
import Hero from "components/Hero"
import Layout, { Container, Section } from "components/Layout"
import SEO from "components/Seo"
import { Heading } from "components/Text"
import { prisma } from "lib/prisma"
import { slugify } from "utils/helpers"

import type { GetStaticPaths, GetStaticProps, NextPage } from "next"
import type { PostWithImagesAndAuthor } from "pages/api/post/read"

const CaseStudy: NextPage<{
  post: PostWithImagesAndAuthor
}> = ({ post }) => {
  return (
    <>
      <SEO
        pageTitle={post?.title ?? ""}
        titleTag={`${post?.title} | Case Study | ${process.env.NEXT_PUBLIC_SITE_NAME}`}
        metaDescription=""
      />
      <Layout>
        <Hero heading={post?.title} />
        <Section>
          <Container>
            <div
              dangerouslySetInnerHTML={{
                __html: post?.content
                  ? generateHTML(JSON.parse(post.content), [StarterKit])
                  : ""
              }}
            />
            <Heading>Gallery</Heading>
            {post?.images && post.images.length > 0 && (
              <div className="grid mdmin:grid-cols-5 gap-2">
                {post.images.map(img => (
                  <AwsImage
                    key={img.id}
                    image={img}
                    alt=""
                    sizes="(max-width: 767px) 100vw, 20vw"
                  />
                ))}
              </div>
            )}
          </Container>
        </Section>
      </Layout>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (!params?.slug) return { notFound: true }
  const posts = await prisma.post.findMany({
    include: {
      author: {
        select: {
          name: true,
          email: true
        }
      },
      images: true
    }
  })

  const post = posts.find(post => slugify(post.title) === params.slug)

  if (!post) return { notFound: true }

  return {
    props: {
      post: JSON.parse(JSON.stringify(post))
    }
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const posts = await prisma.post.findMany({
    where: {
      published: true
    },
    select: {
      title: true
    }
  })
  return {
    paths: posts.map(post => ({
      params: {
        slug: slugify(post.title)
      }
    })),
    fallback: false
  }
}

export default CaseStudy
